import React, { useState } from "react";

import { IUserSignatureProps } from "components/dashboard/product-template-table/utils/interfaces";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";
import { T } from "services/lang/LanguageService";
import "./signature.css";
import { fmtDatetime } from "utils/time-utils";
import { useTimezone } from "hooks/useTimezone";
import { DATE_FORMATTER_MINUTES } from "utils/constants";

export default function UserSignature(props: IUserSignatureProps) {
  const tz = useTimezone();
  // @ts-ignore
  const dateDisplay = new Date(props.value.signedAt);
  const [visible, setVisible] = useState<boolean>(false);

  const datestring = fmtDatetime(dateDisplay, tz.display, DATE_FORMATTER_MINUTES);

  const className = makeid(10);
  const targetClassName = `.${className}`;

  function makeid(length: number) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const accept = () => {
    props.changeHandler();
  };

  return (
    <div
      className="p-inputtext"
      style={{ border: "0px", backgroundColor: "transparent", display: "flex", justifyContent: "center" }}
    >
      <Tooltip target={targetClassName} mouseTrack mouseTrackLeft={10} />
      {props.value && props.value.signed ? (
        <span style={{ display: "flex", flexWrap: "nowrap" }}>
          <span
            className={`${className} non-printable`}
            data-pr-tooltip={`${T("message.user-signature.signed-by-name-at-time", { signedBy: props.value.display, time: datestring })} ${props.value.display}`}
          >
            <i className="pi pi-lock " />
          </span>
          <span
            className="black-color-font"
            style={{ color: "forestgreen", paddingLeft: "10px", fontSize: "14px", textAlign: "center" }}
          >
            {props.value.display}
          </span>
        </span>
      ) : (
        <span className="non-printable" style={{ color: "crimson", display: "flex", flexWrap: "nowrap", alignItems: "center" }}>
          <Button
            className="p-button-icon"
            style={{
              backgroundColor: "crimson",
              border: "crimson",
              padding: "2px",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
            onClick={() => setVisible(true)}
            disabled={props.isInEditMode}
          >
            <i className="pi pi-lock" style={{ margin: "2px" }} />
          </Button>
          <span style={{ paddingLeft: "10px", fontSize: "14px", textAlign: "center" }}>
            {T("message.user-signature.unsigned")}
          </span>
        </span>
      )}

      <ConfirmDialog
        visible={visible}
        onHide={() => setVisible(false)}
        message={T(
          "confirm-dialog.user-signature.do-you-really-want-to-sign-this-entry-row-further-modifications-will-not-be-allowed"
        )}
        acceptClassName="p-button-info"
        rejectClassName="p-button-text p-button-danger"
        header={T("label.user-signature.signature-confirmation")}
        icon="pi pi-lock"
        accept={accept}
        reject={() => {}}
      />
    </div>
  );
}